var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.object.logo)?_c('div',{staticClass:"box-company-logo"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.object.logo,"onerror":"this.src='https://placeimg.com/100/100/tech'"}})]):_c('div',{staticClass:"box-company-logo"},[_c('img',{staticClass:"icon icon-svg",attrs:{"src":"/static/svg/icon_clarity-building.svg"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14a5f5e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanyLogo.vue
// module id = null
// module chunks = 